import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class FinancialsService {
  protected endpoint?: string;
  protected customerDetails?: any;

  constructor(private apiService: ApiService) {
    this.endpoint = 'financials';
  }

  getFinancialListing() {
    return this.apiService.get('customer/financials', {}, true);
  }

  getProviderFinancialListing(params: { page: number; pageSize: number; sortModel?: any; filterModel?: any }) {
    return this.apiService.get('provider/financials/datatable', params, true);
  }

  /** Payouts, newest first. The provider comes from the token; the API takes `pagesize` (max 200). */
  getProviderDisbursements(params: { page: number; pagesize: number }) {
    return this.apiService.get('provider/financials/disbursements', params, true);
  }

  /** Every row of the provider's financials as CSV (the grid's filters do not apply). Full response, for the filename header. */
  exportProviderFinancials() {
    return this.apiService.get('provider/financials/export', {}, true, { responseType: 'blob', observe: 'response' });
  }

  /** The booking's invoice PDF (can hold several invoice pages). Errors arrive as a JSON blob. */
  getProviderInvoice(bookingId: number) {
    return this.apiService.get('provider/financials/invoice', { booking_id: bookingId }, true, {
      responseType: 'blob',
      observe: 'response',
    });
  }

  /** The Zai escrow item behind a payment status, with its payouts. Errors: 401, 404, 422, 502 (Zai unavailable). */
  getProviderItemDetail(itemId: number) {
    return this.apiService.get('provider/financials/item-detail', { item_id: itemId }, true);
  }

  /** Escrow still held for jobs in progress (`amount_held`). The provider comes from the token. */
  getProviderWallet() {
    return this.apiService.get('provider/financials/wallet', {}, true);
  }

  /** Page-level totals for the summary cards; they do not depend on any grid filter. */
  getProviderFinancialSummary() {
    return this.apiService.get('provider/financials/summary', {}, true);
  }
}
